<template>
    <el-dialog width="544px" :style="{ '--el-dialog-padding-primary': 0 }" v-model="visible" append-to-body :show-close="false" :close-on-click-modal="false">
        <template #header>
            <div class="user-title">
                <span>{{ type === 'add' ? '选择您要登录的账号' : '选择您要切换的账号' }}</span>
                <el-icon @click="visible = false"><Close style="cursor: pointer;" /></el-icon>
            </div>
        </template>
        <div class="user-content">
            <el-scrollbar style="max-height: 372px;" :style="{ height: heightValue }">
                <div class="user-content-item" @click="changeUser(item)" :class="curUser.userId === item.userId ? 'active-user' : ''" v-for="(item, index) in userList" :key="index">
                    <div class="user-img">
                        <img :src="dealDefaultAvatar(item)" alt="">
                    </div>
                    <div class="user-info">
                        <div class="title elli">{{ item.username }}</div>
                        <div class="tips elli">{{ item.realname }}</div>
                    </div>
                    <div class="user-cur">当前使用</div>
                </div>
            </el-scrollbar>
            <div class="user-content-item" @click="goAddUser" style="margin: 20px 24px 0 24px;" v-if="type !== 'add'">
                <div class="user-img">
                    <el-icon size="32" color="#CECECE"><Plus /></el-icon>
                </div>
                <div class="user-info">
                    添加账号
                </div>
            </div>
        </div>
    </el-dialog> 
</template>

<script>
import { changelogin, getaccesstoken } from '@/port/pages/login'
import { cloneDeep } from 'lodash'
import { Close } from '@element-plus/icons-vue'
export default {
    // 组件名称
    name: 'changeUser',
    // 组件参数 接收来自父组件的数据
    props: {
        isView: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: ()=> ([])
        },
        type: {
            type: String,
            default: 'change'
        }
    },
    // 局部注册的组件
    components: {
        Close
    },
    // 组件状态值
    data() {
        return {
            visible: false,
            userList: [],
            curUser: {}
        }
    },
    // 计算属性
    computed: {
        heightValue() {
            let len = this.userList.length
            if (len === 1) {
                return '108px'
            } else if (len <= 3) {
                return `${((len - 1) * 24) + (len * 108)}px`
            } else {
                return '372px'
            }
        }
    },
    // 侦听器
    watch: {
        isView: {
            immediate: true,
            handler(val) {
                if (val) {
                    if (this.type === 'add') {
                        this.userList = cloneDeep(this.list)
                    } else {
                        const msg = JSON.parse(localStorage.getItem('userMsg'))
                        const list = localStorage.getItem('userList')
                        const user = {
                            sex: msg.sex,
                            schoolId: msg.schoolMsg.schoolId,
                            userId: msg.userId,
                            username: msg.username,
                            realname: msg.realname,
                            avatar: msg.avatar
                        }
                        this.curUser = user
                        if (list) {
                            // 本地缓存有用户列表
                            const users = JSON.parse(list)
                            // 再去判断用户列表里面是否有当前登录的用户
                            const idx = users.findIndex(item => item.userId === user.userId)
                            this.userList = users
                            if (idx === -1) this.userList.unshift(user)
                        } else {
                            // 如果说本地缓存没有用户列表 直接显示当前登录用户
                            this.userList.push(user)
                            localStorage.setItem('userList', JSON.stringify(this.userList))
                        }
                    }
                    this.visible = true
                }
            }
        },
        visible: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.$emit('update:isView', false)
                }
            }
        }
    },
    // 组件方法
    methods: {
        dealDefaultAvatar(item) {
            let avatar = item.avatar
            let url = ''
            if (avatar) {
                if (avatar.includes('img-')) {
                    url = this.$imgurl + avatar
                } else {
                    const list = avatar.split('/')
                    const num = list[list.length - 1]
                    let format = `${num}.jpg`
                    if (Number(num) >= 36) {
                        format = `${num}.svg`
                    }
                    url = `https://bigdata.topeti.com/PCRepository/middleground/avatar/${format}`
                }
            } else {
                if (item.sex && item.sex === '女') {
                    url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/16.jpg'
                } else {
                    url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg'
                }
            }
            return url
        },
        goAddUser() {
            this.$router.push({
                path:'/addLogin'
            })
        },
        changeUser(item) {
            let accesstoken = "";
            for (let i = 0; i < 6; i++) {
                accesstoken += Math.floor(Math.random() * 10);
            }
            this.goAjaxLogin({ userId: item.userId, accesstoken})
        },
        async goAjaxLogin(param) {
            const res = await changelogin(param)
            if (res.code === 0) {
                const data = res.data
                this.$store.state.postUrl = [];
                data.schoolMsg = data.listschool[0];
                localStorage.setItem("userMsg", JSON.stringify(data));
                let date = {
                    schoolId: data.schoolMsg.schoolId,
                    openId: data.userId,
                    accesstoken: param.accesstoken
                };
                const res1 = await getaccesstoken(date)
                if (res1.code === 0) {
                    localStorage.setItem("user", JSON.stringify(res1.data));
                    document.cookie = "accesstoken=" + res1.data.accesstoken + ";path=/";
                    this.$store.dispatch('setAsyncUserData')
                    if (this.type === 'add') {
                        this.$router.push('/index')
                    } else {
                        window.location.reload()
                    }
                } else {
                    this.$message.error('请求错误')
                }
            }
        }
    },
}
</script> 

<style scoped lang="scss">

.user-title {
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 57px;
    border-radius: 16px 16px 0 0;

    span {
        color: #000000;
        font-weight: 500;
        font-size: 18px;
    }

    .el-icon-close {
        font-size: 18px;
        cursor: pointer;

        &:hover {
            color: #4e86ff;
        }
    }
}
::v-deep.user-content {
    height: 565px;
    box-sizing: border-box;
    border-radius: 0 0 16px 16px;
    padding: 3px 0 48px 0;

    .el-scrollbar {
        .el-scrollbar__view {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
    }

    &-item {
        width: 496px;
        height: 108px;
        background-color: #fff;
        display: flex;
        align-items: center;
        border: solid 1px #EDEDED;
        border-radius: 12px;
        padding: 0 104px 0 20px;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        margin-bottom: 24px;

        &:last-of-type {
            margin-bottom: 0;
        }

        .user-cur {
            display: none;
            color: #4e86ff;
            position: absolute;
            right: 20px;
            top: 30px;
        }

        .user-img {
            width: 68px;
            height: 68px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: solid 1px #EDF5FF;
            border-radius: 100%;
            box-sizing: border-box;

            .el-icon-plus {
                font-size: 40px;
                color: #CECECE;
            }

            img {
                width: 100%;
                height: 100%;
                border-radius: 100%;
            }
        }

        .user-info {
            margin-left: 20px;
            color: #666666;
            font-size: 18px;

            .title {
                color: #000000;
                font-weight: 400;
                font-size: 18px;
                margin-bottom: 7px;
                line-height: 25px;

            }

            .elli {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }

            .tips {
                color: #666666;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
            }
        }
    }

    .active-user {
        background-color: rgba(78, 134, 255, 0.06);
        border-color: #4e86ff;

        .user-cur {
            display: inline-block;
        }
    }
}
</style>
